/**
 * Formats an activity technical id with the Factur-X / PA short prefix
 * (TS_, FEE_, OC_, DP_), matching invoicing ActivityIdParser.formatDisplayId.
 */
export function formatActivityDisplayId(
  prefix: string,
  id: string | number | null | undefined,
): string {
  if (id === null || id === undefined || id === '') {
    return '';
  }
  return `${prefix}_${id}`;
}
